import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Icon from "../elements/icon";
import Button from "../elements/button";
import Popover2 from "../overlays/popover-2";
import KeyPressManager from "../../utils/keypress-manager";
import { prevFocusWithWrap, nextFocusWithWrap } from "../../utils/accessibility-utils";

const Listbox = ({
  className,
  ariaLabel,
  value,
  emptyValue = "Select...",
  children,
  disabled = false,
  onClose,
  size = "dynamic",
  icon = "chevron-down",
  buttonClassName = "",
  hideSelectedValue = false,
  onOpen = () => {},
}) => {
  const width = size === "small" ? "100" : size === "large" ? "300" : "200";
  const widthClass = size !== "dynamic" && size !== "compact" && `et-listbox--width-${width}`;

  return (
    <Popover2
      className={className}
      placement="bottom-start"
      onClose={onClose}
      trigger={({ togglePopover }) => (
        <Button
          className={classNames("et-listbox--trigger", buttonClassName, widthClass, {
            "has-value": value !== "" && value !== emptyValue,
          })}
          type={size === "compact" ? "simple" : "secondary"}
          onClick={() => {
            togglePopover();
            onOpen();
          }}
          accessibilityAttributes={{ "aria-haspopup": "listbox" }}
          label={ariaLabel}
          disabled={disabled}
        >
          {!hideSelectedValue && <div className="et-listbox--label">{value || emptyValue}</div>}
          <Icon size={1} icon={icon} />
        </Button>
      )}
    >
      {({ closePopover }) => (
        <KeyPressManager
          component="div"
          onArrowDown={(node) => nextFocusWithWrap(node)}
          onArrowUp={(node) => prevFocusWithWrap(node)}
        >
          <div className="et-listbox--content" role="listbox">
            {children({ closePopover })}
          </div>
        </KeyPressManager>
      )}
    </Popover2>
  );
};

Listbox.propTypes = {
  className: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
  value: PropTypes.string,
  emptyValue: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large", "dynamic", "compact"]),
  icon: PropTypes.string,
  buttonClassName: PropTypes.string,
  hideSelectedValue: PropTypes.bool,
  onOpen: PropTypes.func,
};

export default Listbox;
